import { render, staticRenderFns } from "./wzzj4.vue?vue&type=template&id=01e936d6&scoped=true&"
import script from "./wzzj4.vue?vue&type=script&lang=js&"
export * from "./wzzj4.vue?vue&type=script&lang=js&"
import style0 from "./wzzj4.vue?vue&type=style&index=0&id=01e936d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e936d6",
  null
  
)

export default component.exports